<app-shell-admin-warning-banner></app-shell-admin-warning-banner>
<div class="request-page-header">
	<div class="request-page-header__eyebrow">Company administration</div>
	<h2>Sub-company requests</h2>
	<p>Review requests to create or link sub-companies. Use User access requests when a user only needs access to an existing company.</p>
</div>
<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid [dataSource]="viewModel.dataSource" [showBorders]="true">
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-paging [enabled]="false"></dxo-paging>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing [allowAdding]="false" [allowUpdating]="canHandleCompanyRequests" [allowDeleting]="canHandleCompanyRequests"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="companyId"
			caption="Company"
			[allowEditing]="false"
		>
			<dxo-lookup
				[dataSource]="viewModel.companyDatasource"
				valueExpr="id"
				[displayExpr]="companyIdDisplayExpr"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="userId"
			caption="User"
			[allowEditing]="false"
		>
			<dxo-lookup
				[dataSource]="viewModel.userDatasource"
				valueExpr="id"
				displayExpr="displayName"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="userEmail"
			caption="User email"
		>
		</dxi-column>
		<dxi-column
			dataField="newSubCompanyName"
			caption="New company name"
		>
		</dxi-column>

		<dxi-column type="buttons" *ngIf="canHandleCompanyRequests">
			<dxi-button icon="far fa-check btn-succes" hint="Approve" [onClick]="approve.bind(this)">
			</dxi-button>
			<dxi-button icon="far fa-ban btn-danger" hint="Reject" [onClick]="reject.bind(this)">
			</dxi-button>
		</dxi-column>
	</dx-data-grid>
</ng-container>
